<template>
  <el-menu :default-active="active" class="side-menu el-menu-vertical-demo" unique-opened>
    <transition name="slide" duration="100">
      <ul v-if="open" :key='1'>
        <template v-for="menu in formatMenu(menus)">
          <menu-item :menu="menu" :key="menu.id"></menu-item>
        </template>
      </ul>
      <ul class="iconmenu-list" v-else :key="2">
        <template v-for="(menu) in formatMenu(menus)">
          <el-tooltip popper-class="aside-tooltip" :visible-arrow="false" :manual="false" placement="right"  :key="menu.meta.menuId" v-if="menu.children && menu.children.length>0">
            <template slot="content">
              <ul class="iconchild-list" @mouseleave="mouseenterIndex=''" @mouseenter="mouseenterItem(menu)" >
                <li class="iconchild-list-item" :class="activeMenuId === child.meta.menuId ?'active':''" v-for="child in formatMenu(menu)" :key="child.meta.menuId" @click="goTab(child)">
                  <span >{{child.meta.zhname}}</span>
                </li>
              </ul>
            </template>
            <el-menu-item class="iconmenu-item" :index="menu.meta.menuId"  @click="goTab(menu)" :class="{active: activeIcon.indexOf(menu.path)!==-1 ,mouseenter: mouseenterIndex === menu.meta.menuId}">
              <span class="menu-icon iconfont" @mouseenter="mouseenterItem(menu)"  @mouseleave="mouseenterIndex=''" :class="'icon'+menu.meta.icon"></span>
            </el-menu-item>
          </el-tooltip>
          <el-menu-item v-else class="iconmenu-item"   :index="menu.meta.menuId" :class="{active: activeMenuId === menu.meta.menuId }" @click="goTab(menu)" :key="menu.meta.menuId">
              <span class="menu-icon iconfont" :class="'icon'+menu.meta.icon"></span>
          </el-menu-item>
        </template>
      </ul>
    </transition>
  </el-menu>
</template>
<script>
import { mapGetters } from 'vuex'
import MenuItem from './MenuItem'
export default {
  name: 'sideMenu',
  props: {
    open: {
      type: Boolean
    }
  },
  components: {
    MenuItem
  },
  data () {
    return {
      activeMenuId: '',
      mouseenterIndex: ''
    }
  },
  computed: {
    ...mapGetters({
      'menus': 'childrenRoutes',
      'activeTab': 'activeTab'
    }),
    active () {
      return this.activeTab.meta ? this.activeTab.meta.menuId : ''
    },
    activeIcon () {
      return this.$route.fullPath
    }
  },
  methods: {
    mouseenterItem (menu) {
      this.mouseenterIndex = menu.meta.menuId
    },
    formatMenu (tree) {
      if (!(tree instanceof Array)) {
        tree = tree.children
      }
      return tree.filter(item => {
        return item.meta.type === 'menu' && !item.meta.singlePage && !item.meta.hideInAdmin
      })
    },
    goTab (menu) {
      this.activeMenuId = menu.meta.menuId
      if (menu.children.length > 0) {
        this.$router.push({name: menu.children[0].name})
      } else {
        this.$router.push({name: menu.name})
      }
    }
  }
}
</script>

<style lang="less">
.side-menu {
 overflow-y: auto;
 overflow-x: hidden;
 background-color: #2f5a80;
 border-right: none;
 height: 100%;
 width: 100%;
 .el-menu {
   background-color: #2F5A80;
   text-align: left;
   &.el-menu--inline{
     background-color: #23415c;
   }
   &:focus{
     background-color: transparent;
   }
 }
 .menu-child-group{
   .el-submenu{
     background-color: #23415c;
   }
  //  .el-submenu__title,.el-menu-item{
  //    .menu-icon{
  //      display: none;
  //    }
  //  }
   &.service{
     .el-submenu__title,.el-menu-item{
        .menu-icon{
          display: inline-block;
        }
      }
   }
 }
 .el-menu-item-group__title {
   padding: 0;
 }
 .menu-item:hover,.menu-item:focus {
   background-color: #009dc2;
 }
 .el-submenu {
   .el-submenu__title .el-icon-caret-right {
     transition: transform 0.3s;
   }
   &.is-opened > .el-submenu__title{
     color: #fff;
   }
   &.is-opened > .el-submenu__title .el-icon-caret-right {
     transform: rotateZ(90deg);
   }
 }
 .el-submenu__title {
   height: 48px;
   line-height: 48px;
   font-size: 14px;
   color:#ccc;
   text-align: left;
   font-weight: bold;
  //  i {
  //    background-repeat: no-repeat;
  //    background-position: center;
  //    background-size: 100%;
  //    font-size: 18px;
  //    color:#ccc;
  //  }
   &:hover,&:focus {
     color:#fff;
     background-color: #294b6a;
   }
 }
 .el-menu-item,.el-submenu{
   background-color: #2F5A80;
 }
 .el-submenu{
   .el-menu-item{
     background-color: #23415c;
   }
 }
 .el-menu-item {
   position: relative;
   height: 48px;
   line-height: 48px;
   font-size: 14px;
   color:#ccc;
   font-weight: bold;
   &.is-active {
     background-color: #009dc2 !important;
     color: #fff;
     i {
       color: #fff;
     }
     &:hover,&:focus {
      //  background-color: #294b6a;
     }
   }
   &:hover,&:focus {
     color: #fff;
     background-color: #294b6a;
   }
 }
 img {
   width: 18px;
   height: 18px;
   margin-right: 10px;
   margin-bottom: 2px;
 }
 .menu-icon{
  font-size: 16px;
   background-repeat: no-repeat;
   background-size: 100%;
   display: inline-block;
 }
 .iconmenu-list{
   .menu-icon{
     color: #ccc;
   }
    .mouseenter {
        background-color: #294b6a !important;
    }
   .iconmenu-item{
    line-height: 48px;
    height: 48px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    cursor: pointer;
    position: relative;
     &.active{
      background-color: #009dc2;
      &:hover {
      background-color: #294b6a;

      }
      .menu-icon{
        color: #fff;
      }
    }
   }
 }

 .el-submenu__icon-arrow{
   margin-top: -5px;
 }
 .el-submenu__icon-arrow.el-icon-arrow-down:before {
   content: "" !important;
 }
 .el-submenu__icon-arrow.el-icon-arrow-down {
   display: inline-block !important;
   width: 10px;
   height: 10px;
   background-image: url(../../../assets/images/menu-down.png);;
   background-size: cover;
   transform: rotate(180deg);
 }
 .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
   transform: rotate(0deg);
 }
 .el-menu-item.is-active {
    background-color: #009dc2;
   position: relative;
   &:hover {
    // background-color: #294b6a;
   }
 }
 .slide-enter-to,.slide-enter-active{
  display: none;
 }
}
.aside-tooltip{
  padding: 0;
  background-color: transparent;
  left: 48px !important;
  .iconchild-list{
    list-style-type: none;
    &-item{
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      color: #fff;
      background-color: #294b6a;
      color: rgba(255, 255, 255, .8);
      padding:0 24px;
      cursor: pointer;
      &:hover{
        background-color: #009dc2;
      }
      &.active{
        background-color: #009dc2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/area-base/views/layout/SideMenu/index.vue